<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="listQuery.inn_id" placeholder="锦江酒店ID" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.room_type_name" placeholder="房型名称" style="width: 220px;" clearable
                size="small"/>
      <el-input class="filter-item" v-model="listQuery.product_name" placeholder="商品名称" style="width: 220px;" clearable
                size="small"/>
      <el-date-picker
          v-model="dateArr"
          type="datetimerange"
          :default-time="['00:00:00', '23:59:59']"
          align="right"
          value-format="yyyy-MM-dd HH:mm:ss"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="filter-item"
          style="display: inline-flex"
          size="small"
      ></el-date-picker>
      <el-button class="filter-item" type="primary" @click="handleFilter" size="small">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
      <el-table-column label="ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="锦江酒店ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.inn_id }}
        </template>
      </el-table-column>
      <el-table-column label="房型编号(兼容第三方)" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_type_code||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="房型名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_type_name||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="房型英文名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_type_name_en||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="商品编号" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.product_code||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="商品名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.product_name||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="商品类型" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.product_type||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="预付早餐" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.advance_breakfast_count||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="预付其他费用" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.advance_fee_rate||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="营业日期" min-width="120" align="center">
        <template slot-scope="scope">
          {{scope.row.end_of_day?moment(Number(scope.row.end_of_day)).format("YYYY-MM-DD"):"-" }}
        </template>
      </el-table-column>
      <el-table-column label="开始时间" min-width="120" align="center">
        <template slot-scope="scope">
          {{scope.row.start_time?moment(Number(scope.row.start_time)).format("YYYY-MM-DD HH:mm:ss"):"-" }}
        </template>
      </el-table-column>
      <el-table-column label="结束时间" min-width="120" align="center">
        <template slot-scope="scope">
          {{scope.row.end_time?moment(Number(scope.row.end_time)).format("YYYY-MM-DD HH:mm:ss"):"-" }}
        </template>
      </el-table-column>
      <el-table-column label="免费取消时间" min-width="120" align="center">
        <template slot-scope="scope">
          {{scope.row.free_cancel_time?moment(Number(scope.row.free_cancel_time)).format("YYYY-MM-DD HH:mm:ss"):"-" }}
        </template>
      </el-table-column>
      <el-table-column label="本地预付价格" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.advance_rate||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="零售价" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.retail_price||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="入住成人数" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.guests||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="原预付价" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.orig_advance_rate||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="原现付价" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.orig_spot_rate||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="可售房量" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.quota||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="门市价" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.rack_rate||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column label="同步时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.sync_at }}
        </template>
      </el-table-column>
      <el-table-column label="同步时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.sync_at }}
        </template>
      </el-table-column>
<!--      <el-table-column label="操作" width="250" align="center" fixed="right" class-name="small-padding fixed-width">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button type="warning" size="mini" @click="handleSalesRoomType(scope.row)">售卖房型</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import moment from "moment";

  export default {
    computed: {
      moment() {
        return moment
      }
    },
    watch: {
      dateArr(newVal) {
        if (newVal) {
          this.listQuery.start_at = newVal[0];
          this.listQuery.end_at = newVal[1];
        } else {
          this.listQuery.start_at = "";
          this.listQuery.end_at = "";
        }
      },
    },
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        dateArr: null,
        listQuery: {
          page: 1,
          limit: 10,
          hotel_name: "",
          basic_room_type_name: "",
        },
      };
    },
    created() {
      this.getList();
    },
    methods: {
      getList() {
        this.listLoading = true;
        request({
          url: "/api/backend/jinJiang/hotel/hotelRoomStatusList",
          method: "get",
          params: this.listQuery,
        }).then(response => {
          this.list = response.data.items;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      // 售卖房型
      handleSalesRoomType(row) {
        this.$router.push(`/salesRoomTypeList?basic_room_type_id=${row.id}`);
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
